"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorObject = void 0;
/**
 * This function is helpful if you need to parse the relevant details
 * from a typical api response error object
 *
 */
var getErrorObject = function (errorString) {
    var matches = errorString.match(/errorCode: "(?<errorCode>.*?)"\nmessage: "(?<message>.*?)"/);
    // Property 'groups' does not exist on type 'RegExpMatchArray'. 
    // @ts-ignore
    if (!(matches === null || matches === void 0 ? void 0 : matches.groups))
        return;
    // @ts-ignore
    var _a = matches.groups, errorCode = _a.errorCode, message = _a.message;
    return { errorCode: errorCode, message: message };
};
exports.getErrorObject = getErrorObject;
